import apiClient from '../apiClient';
import { POST_ACCEPT_QUOTATION_URL } from '../apiUrl';

const postAcceptQuotationApi = id => {
  return apiClient.post(POST_ACCEPT_QUOTATION_URL(id));
};

export default postAcceptQuotationApi;
